import { _js } from '@ifixit/utils/localize';
import { faLegacyIconSvg } from 'Shared/faLegacyIcon';

// eslint-disable-next-line no-var
export var FullScreenController = (window.FullScreenController = (function () {
   let doc = document;
   let docElement = doc.documentElement;
   // The icon classes sit on the button itself (embed.v4.header.ejs);
   // the old `.js-fullscreen > i` matched nothing and the icon froze.
   let iconSelector = '.js-fullscreen';

   function isFullScreen() {
      return doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement;
   }

   function syncIcon() {
      const fullScreen = isFullScreen();
      const name = fullScreen ? 'compress' : 'expand';
      const other = fullScreen ? 'expand' : 'compress';
      $(iconSelector)
         .removeClass('fa-' + other)
         .addClass('fa-' + name)
         .attr('aria-label', fullScreen ? _js('Exit fullscreen') : _js('Fullscreen'))
         .html(faLegacyIconSvg(name));
   }

   // Event-driven, not click-time: Esc/F11 exits still swap, and a denied
   // request (iframe without allowfullscreen) fires no event, so no swap.
   function watchFullscreenChanges(watchedDoc) {
      if (watchedDoc.fullscreenIconSyncBound) {
         return;
      }
      watchedDoc.fullscreenIconSyncBound = true;
      ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach(eventName =>
         watchedDoc.addEventListener(eventName, syncIcon)
      );
   }

   watchFullscreenChanges(doc);

   function openFullscreen(checkSupport) {
      if (docElement.requestFullscreen) {
         checkSupport || docElement.requestFullscreen();
         /**
 * According to http://caniuse.com/#feat=fullscreen IE11 doesn't really support
 * fullscreening an iframe :-(
      } else if (docElement.msRequestFullscreen) {
         checkSupport || docElement.msRequestFullscreen();
*/
      } else if (docElement.mozRequestFullScreen) {
         checkSupport || docElement.mozRequestFullScreen();
      } else if (docElement.webkitRequestFullscreen) {
         checkSupport || docElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else {
         return false;
      }

      return true;
   }

   function closeFullscreen() {
      if (doc.exitFullscreen) {
         doc.exitFullscreen();
      } else if (doc.msExitFullscreen) {
         doc.msExitFullscreen();
      } else if (doc.mozCancelFullScreen) {
         doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
         doc.webkitExitFullscreen();
      }
   }

   function toggleFullScreen() {
      if (isFullScreen()) {
         closeFullscreen();
      } else {
         openFullscreen();
      }
   }

   return {
      toggle: toggleFullScreen,

      toggleParentFullscreen: function () {
         doc = window.parent.document;
         docElement = doc.documentElement;
         // Nothing in this repo emits .js-operator-fullscreen, so its markup
         // is unverified; keep the selector this path always had.
         iconSelector = '.js-operator-fullscreen > i';
         watchFullscreenChanges(doc);
         toggleFullScreen();
      },

      supported: function () {
         return openFullscreen(/* check support */ true);
      },
   };
})());
